import axios from 'axios';
import { setupRequestInterceptor } from './interceptors/requestInterceptor';
import { setupResponseInterceptor } from './interceptors/responseInterceptor';
import { API_BASE_URL } from 'constants';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Store reference (will be set from index.js)
let storeRef = null;

export const setStore = (store) => {
  storeRef = store;
};

export const getStore = () => storeRef;

// Setup interceptors
setupRequestInterceptor(axiosInstance);
setupResponseInterceptor(axiosInstance);

// Request deduplication - prevents duplicate GET requests (e.g., from React StrictMode)
const pendingRequests = new Map();

const deduplicatedGet = (url, config = {}) => {
  const requestKey = `GET:${url}`;

  // If request is already in flight, return the same promise
  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  // Create new request and store the promise
  const request = axiosInstance.get(url, config).finally(() => {
    pendingRequests.delete(requestKey);
  });

  pendingRequests.set(requestKey, request);
  return request;
};

// API helper methods
export const api = {
  get: (url, config = {}) => deduplicatedGet(url, config),

  post: (url, data, config = {}) => axiosInstance.post(url, data, config),

  put: (url, data, config = {}) => axiosInstance.put(url, data, config),

  patch: (url, data, config = {}) => axiosInstance.patch(url, data, config),

  delete: (url, config = {}) => axiosInstance.delete(url, config),

  // File upload with progress
  upload: (url, formData, onProgress) => {
    return axiosInstance.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
  },
};

export default axiosInstance;
